import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", localStorage.getItem("theme") || "dark");
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 30,
        y: (e.clientY / window.innerHeight - 0.5) * 30,
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="nf">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Mono:ital,wght@0,400;0,700;1,400&display=swap');

        .nf {
          min-height: 100vh;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background: var(--bg);
          font-family: 'Space Mono', monospace;
          padding: 20px;
          overflow: hidden;
        }

        .nf-inner {
          position: relative;
          z-index: 10;
          text-align: center;
          max-width: 500px;
          width: 100%;
        }

        .nf-code {
          font-size: clamp(6rem, 20vw, 10rem);
          font-weight: 700;
          line-height: 1;
          margin: 0 0 20px;
          color: var(--brand);
          animation: glitch 3s infinite ease-in-out;
        }

        @keyframes glitch {
          0%, 70%, 100% { transform: translate(0, 0) skew(0deg); }
          72% { transform: translate(-3px, 1px) skew(-1deg); }
          74% { transform: translate(3px, -1px) skew(1deg); }
          76% { transform: translate(-1px, 2px) skew(-0.5deg); }
          78% { transform: translate(1px, -2px) skew(0.5deg); }
          80% { transform: translate(-2px, 0) skew(0.5deg); }
          82% { transform: translate(2px, 0) skew(-0.5deg); }
          85%, 90% { transform: translate(0, 0) skew(0deg); }
          92% { transform: translate(-2px, 1px) skew(-0.8deg); }
          94% { transform: translate(2px, -1px) skew(0.8deg); }
          96% { transform: translate(-1px, 1px) skew(-0.3deg); }
          98% { transform: translate(1px, -1px) skew(0.3deg); }
        }

        .nf-line {
          font-size: 1.2rem;
          margin: 0 0 16px;
          color: var(--text);
          font-style: italic;
          line-height: 1.5;
        }

        .nf-desc {
          color: var(--text-muted);
          font-size: 0.9rem;
          margin: 0 0 40px;
          line-height: 1.7;
        }

        .nf-btn {
          padding: 14px 32px;
          font-size: 0.85rem;
          font-family: 'Space Mono', monospace;
          font-weight: 700;
          background: transparent;
          color: var(--text);
          border: 2px solid var(--border);
          cursor: pointer;
          transition: border-color 0.2s, color 0.2s;
          text-transform: uppercase;
          letter-spacing: 1.5px;
        }

        .nf-btn:hover {
          border-color: var(--brand);
          color: var(--brand);
        }

        @media (max-width: 600px) {
          .nf-code {
            font-size: clamp(4rem, 20vw, 6rem);
          }
          .nf-line {
            font-size: 1rem;
          }
        }
      `}</style>

      <div className="nf-inner">
        <h1
          className="nf-code"
          style={{
            transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`,
            transition: 'transform 0.08s ease-out',
          }}
        >
          404
        </h1>

        <h2 className="nf-line">
          "I explicitly told this page to exist, but it ignored me."
        </h2>

        <p className="nf-desc">
          You've found a glitch in the matrix. The page you are looking for has been moved, deleted, or perhaps it never existed in this timeline.
        </p>

        <button className="nf-btn" onClick={() => navigate('/')}>
          Return to Base
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
